var _defs, _circle, _path, _circle2, _circle3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHappy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcd844;}.cls-2{fill:#363636;}.cls-3{fill:#ff5961;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-happy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 350
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500,717.66c-44.53,0-87.2-14.68-123.38-42.46C341.49,648.23,315,611,300,567.5a15.64,15.64,0,0,1,14.79-20.74H685.17A15.64,15.64,0,0,1,700,567.5c-15,43.49-41.45,80.73-76.58,107.7C587.2,703,544.53,717.66,500,717.66Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 353.38,
    cy: 417.53,
    r: 52.28
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 646.62,
    cy: 417.53,
    r: 52.28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M611.66,644.21c-31.35,26.66-70.48,42.16-111.66,42.16s-80.31-15.5-111.66-42.16C410.31,618.39,452.09,601,500,601S589.69,618.39,611.66,644.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M611.66,644.21c-31.35,26.66-70.48,42.16-111.66,42.16s-80.31-15.5-111.66-42.16C410.31,618.39,452.09,601,500,601S589.69,618.39,611.66,644.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappy);
export default __webpack_public_path__ + "static/media/icon-happy.ee3e343c72a568127d40db99302298c5.svg";
export { ForwardRef as ReactComponent };